import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { LpCanvasService } from '@core/lp/lp-canvas.service';
import { ICanvasElement } from '@features/canvas/canvas.types';
import { useElementSize } from '@shared/angular.utils';
import { workaroundCanvasRatio } from '@shared/workarounds.utils';
import { LpClickActivity } from '@typings/lp/generated';
import { CanvasRendererComponent } from '../../canvas/canvas-renderer/canvas-renderer.component';
import { LpMissionService } from '../lp-mission/lp-mission.service';
import { Id } from '@typings/id';

@Component({
  selector: 'lp-click-activity',
  imports: [CanvasRendererComponent],
  templateUrl: './lp-click-activity.component.html',
  styleUrl: './lp-click-activity.component.css',
})
export class LpClickActivityComponent {
  activity = input.required<LpClickActivity>();
  elements = signal<ICanvasElement[]>([]);
  size = computed(() => workaroundCanvasRatio(this.activity().canvasRatio));
  sizeInPixels = useElementSize();

  readonly #lpMissionService = inject(LpMissionService);
  readonly #lpCanvasService = inject(LpCanvasService);

  constructor() {
    effect(async () => {
      this.#lpCanvasService.subscribeToShowIfChanges();

      this.elements.set([
        await this.#lpCanvasService.convertBackground(this.activity().background, this.size()),
        ...(await this.#lpCanvasService.convertClickTargets(this.activity().targets, this.sizeInPixels())),
        ...(await this.#lpCanvasService.convertVisualElements(this.activity().visualElements, this.sizeInPixels())),
      ]);
    });
  }

  async handleClick(id: Id) {
    await this.#lpMissionService.finishActivity(this.activity());
  }
}
